<app-skeleton [loading]="loading" height="220px">
    <app-source-detail [baseInfo]="baseInfo"
        [capacityPercentData]="capacityPercentData"
        [detail]="detail"
        [event]="item"
        [loading]="updateLoading"
        [threSholdList]="threSholdList"
        icon="#infigo-lun"
    >
    </app-source-detail>
</app-skeleton>
